import tabAppFailedTransactions from './tabAppFailedTransactionsWhiteLabel';
import tabAppTransactions from './tabAppTransactionsWhiteLabel';
import tableAppTransactions from './tableAppTransactionsWhiteLabel';

export default {
  title: 'Manual V.T. Transactions',
  attributeName: 'appTransactionPlay',
  getURL: 'appId/appTransactionPlay',
  updateURL: 'appId/appTransactionPlay',
  sessionParams: ['appId'],
  noArea: true,
  tabs: [tabAppTransactions, tabAppFailedTransactions],
  tableConfig: tableAppTransactions,
  initialTab: 'successful',
};
